import { FormDefinition } from '@lbmx/per-form';

export const formDefinition = (fields: any): FormDefinition<any> => ({
  fields,
});
